import { Alert, Box, Button, Container, Paper, Stack, Typography } from '@mui/material';
import { Link as RouterLink, useRouteError } from 'react-router-dom';

/**
 * Catches render errors so a bug shows something honest instead of React
 * Router's developer page — which leaks a stack trace to whoever is standing
 * at the counter.
 */
export function RouteErrorBoundary() {
  const error = useRouteError() as Error | undefined;
  const isDev = import.meta.env.DEV;

  return (
    <Container maxWidth="sm" sx={{ py: { xs: 6, md: 10 } }}>
      <Stack spacing={3}>
        <Box>
          <Typography variant="h4">Something went wrong on this screen</Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mt: 1 }}>
            Nothing you were working on has been posted. Go back and try again — if it keeps
            happening, tell your HXIQ administrator what you were doing.
          </Typography>
        </Box>

        {isDev && error && (
          <Paper variant="outlined" sx={{ p: 2, overflow: 'auto' }}>
            <Typography variant="caption" color="text.secondary">
              Development detail
            </Typography>
            <Box component="pre" sx={{ m: 0, fontSize: 12, whiteSpace: 'pre-wrap' }}>
              {error.message}
            </Box>
          </Paper>
        )}

        {!isDev && <Alert severity="info">The error has been logged.</Alert>}

        <Stack direction="row" spacing={1.5}>
          <Button variant="contained" onClick={() => window.location.reload()}>
            Reload
          </Button>
          {/* /app lands on the first thing on the person's own bar (AppHome). */}
          <Button component={RouterLink} to="/app" variant="outlined">
            Go to your home
          </Button>
        </Stack>
      </Stack>
    </Container>
  );
}
